import { defineStore } from 'pinia';
import { ref } from 'vue';
import { initProject, type Project } from '@/views/ContractCreation/const';

// Define the Pinia store
export const useContractStore = defineStore('contract', () => {
  const project = ref<Project>(initProject);

  const query = ref<string>('');
  const bigProcess = ref<string>('all');
  const selectStatus = ref<string | null>(null);

  return {
    project,
    query,
    bigProcess,
    selectStatus
  };
});
